import React, { useEffect, useState, useRef, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, XIcon } from 'lucide-react';
function VimeoPlayer({
  isFloating,
  onDismiss
}: {
  isFloating: boolean;
  onDismiss: () => void;
}) {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className={`relative z-10 w-full rounded-lg shadow-2xl overflow-hidden transition-all duration-500 ease-in-out ${isFloating ? 'fixed bottom-4 right-4 !w-[300px] md:!w-[380px] z-[90] rounded-xl border border-gold/30' : ''}`} style={isFloating ? {
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.7)'
  } : {}} data-id="element-178">
      <div style={{
      padding: '56.25% 0 0 0',
      position: 'relative'
    }} data-id="element-179">
        <iframe src="https://player.vimeo.com/video/1177040592?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }} title="AI WEBSITE TESTIMONIO" data-id="element-180" />
      </div>
      <AnimatePresence data-id="element-181">
        {isFloating && <motion.button initial={{
        opacity: 0,
        scale: 0.5
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.5
      }} transition={{
        duration: 0.2
      }} onClick={onDismiss} className="absolute top-2 right-2 z-20 p-1.5 rounded-full bg-black/70 hover:bg-black/90 border border-white/20 transition-colors" aria-label="Cerrar video flotante" data-id="element-182">
            <XIcon className="h-3.5 w-3.5 text-white" data-id="element-183" />
          </motion.button>}
      </AnimatePresence>
    </div>;
}
export function HeroLP1() {
  const [currentPrice, setCurrentPrice] = useState(27);
  const [isFloating, setIsFloating] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const videoSentinelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const sentinel = videoSentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        setIsFloating(true);
      } else {
        setIsFloating(false);
        setIsDismissed(false);
      }
    }, {
      threshold: 0.1
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);
  const handleDismiss = () => {
    setIsDismissed(true);
  };
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden px-4 pt-6 pb-20" data-id="element-184">
      {/* Animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy-light to-navy-dark" data-id="element-185">
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-0 right-0 w-96 h-96 bg-gold/20 rounded-full blur-3xl" data-id="element-186" />
        <motion.div animate={{
        scale: [1.2, 1, 1.2],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-187" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-188">
        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center mb-6 md:mb-8" data-id="element-189">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="font-heading font-black text-4xl md:text-5xl lg:text-6xl leading-tight mb-4 md:mb-6" data-id="element-190">
            Gana Tu Primer <span className="text-gold" data-id="element-191">$1,000</span> Esta Semana
            Vendiendo Sitios Web a Negocios Locales
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="font-body text-lg md:text-xl text-gray-300 mb-4" data-id="element-192">
            (La IA los Construye en Minutos. Tú Solo Haces la Llamada.)
          </motion.p>
        </motion.div>

        {/* Hero Video */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="relative mb-6 md:mb-10" data-id="element-193">
          <div ref={videoSentinelRef} className="absolute inset-0 pointer-events-none" data-id="element-194" />
          <VimeoPlayer isFloating={!isDismissed && isFloating} onDismiss={handleDismiss} data-id="element-195" />

          <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent rounded-lg pointer-events-none" data-id="element-196" />
        </motion.div>

        {/* Copy and CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="text-center" data-id="element-197">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.2
        }} className="font-body text-base md:text-lg text-gray-400 mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-198">
            Uno de nuestros miembros contactó 7 negocios en su primera semana.
            Cerró 3. Ganó $1,050. No sabía nada de diseño web. Tú tampoco
            necesitas saberlo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.4
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-199">
            <motion.a href="/checkout" onClick={() => {
            if (window.fbq) window.fbq('track', 'AddToCart', {
              content_name: 'AI Web Closer Course',
              content_type: 'product',
              value: 27,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group bg-gold hover:bg-gold-light text-navy font-heading font-bold text-lg px-8 py-4 rounded-lg shadow-xl transition-all duration-300 flex items-center justify-center gap-2" data-id="element-200">
              Quiero Acceso por ${currentPrice}
              <ArrowRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-201" />
            </motion.a>
          </motion.div>

          
        </motion.div>
      </div>
    </section>;
}